module.exports = __webpack_public_path__ + "img/1920_news_sub_img3.4c8ed369.png";